import { createRoot } from "react-dom/client";
import "./index.css";
import { App } from "./app/App";
import { ThemeProvider } from "./app/providers";
import { ReduxProvider } from "./app/providers";
import { I18nProvider } from "./app/providers";

createRoot(document.getElementById("root")!).render(
  <I18nProvider>
    <ReduxProvider>
      <ThemeProvider>
        <App />
      </ThemeProvider>
    </ReduxProvider>
  </I18nProvider>
);
